"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const WidgetPreviewContainer = (0, _styledBase.default)("div", {
  target: "e5ld4zj0",
  label: "WidgetPreviewContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1wfkwts",
  styles: "margin:15px 2px;"
} : {
  name: "1wfkwts",
  styles: "margin:15px 2px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9XaWRnZXRQcmV2aWV3Q29udGFpbmVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUV5QyIsImZpbGUiOiIuLi8uLi9zcmMvV2lkZ2V0UHJldmlld0NvbnRhaW5lci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuY29uc3QgV2lkZ2V0UHJldmlld0NvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIG1hcmdpbjogMTVweCAycHg7XG5gO1xuXG5leHBvcnQgZGVmYXVsdCBXaWRnZXRQcmV2aWV3Q29udGFpbmVyO1xuIl19 */"
});
var _default = WidgetPreviewContainer;
exports.default = _default;